import type { DocumentChangesView } from "@repo/shared/findingChanges";

/** A failed decision can retry the confirmed version without uploading the proposal twice. */
export function createProposalResolution() {
  const saved = new Map<string, number>();
  const pending = new Map<string, Promise<number>>();
  return (
    proposal: DocumentChangesView,
    currentVersion: number | null,
    upload: () => Promise<number>,
  ) => {
    const version = saved.get(proposal.id);
    if (version !== undefined) return Promise.resolve(version);
    const active = pending.get(proposal.id);
    if (active) return active;
    if (currentVersion !== proposal.sourceVersion)
      return Promise.reject(
        new Error(
          "The policy changed after this proposal. Ask Inspector to update it against the current version.",
        ),
      );
    const promise = Promise.resolve()
      .then(upload)
      .then((version) => {
        saved.set(proposal.id, version);
        return version;
      })
      .finally(() => pending.delete(proposal.id));
    pending.set(proposal.id, promise);
    return promise;
  };
}
